import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

// English translations
const en = {
  nav: { features: 'Features', specs: 'Details', reviews: 'Reviews', faq: 'FAQ', order: 'Order Now' },
  announcement: { text: 'Free delivery inside Dhaka', highlight: 'Order Now!' },
  hero: {
    tagline: 'PROFESSIONAL MAKEUP BRUSH',
    title: 'Loren Aura',
    subtitle: 'Exclusive 13 Pcs Makeup Brush Set — Aluminum Handle, Advanced Fiber Bristles',
    description: '',
    addToCart: 'Add to Cart',
    buyNow: 'Order Now',
    freeShipping: 'Free delivery inside Dhaka',
    selectVariant: 'Select Option',
    popular: 'Best Value',
    freeDelivery: 'Free delivery inside Dhaka',
  },
  features: {
    title: 'Why Choose',
    highlight: 'Loren Aura',
    subtitle: 'Professional quality brushes for the modern beauty enthusiast',
    items: [
      { icon: '🌿', label: 'Soft & Skin Friendly – Safe for sensitive skin' },
      { icon: '⏳', label: 'Long Lasting – Durable quality with regular use' },
      { icon: '✨', label: 'Flawless Blend – Smooth & professional finish' },
      { icon: '🚫', label: 'No Shedding – No hair falls during use' },
      { icon: '🖌️', label: 'Durable Bristles – Premium, long-lasting quality' },
    ],
  },
  setContents: {
    title: '13 Pcs Makeup Brush Set',
    items: [
      { icon: '👤', label: 'Face Brushes × 5 (Powder, Foundation, Angled Contour, Blush, Highlight)' },
      { icon: '✨', label: 'Concealer Brush × 1' },
      { icon: '👁️', label: 'Eye Shadow Brushes × 5 (Small Shadow, Smoky, Blending, Detail, Silkworm)' },
      { icon: '✔️', label: 'Eyebrow Brush × 1' },
      { icon: '💋', label: 'Lip Brush × 1' },
    ],
  },
  useCases: {
    title: 'Perfect For',
    items: ['Daily Makeup Routine', 'Special Occasions & Events', 'Professional Makeup Artists', 'Gift for Beauty Lovers', 'Travel & On-the-Go Touch-ups'],
  },
  productNotes: {
    title: '💄 Product Details',
    description: 'Our brushes feature ultra-soft synthetic bristles that pick up product beautifully and blend seamlessly. The ergonomic handles provide perfect control for flawless application every time.',
    topNote: 'Bristles', topNoteDesc: 'Ultra Soft Synthetic',
    middleNote: 'Handle', middleNoteDesc: 'Ergonomic Wood',
    baseNote: 'Finish', baseNoteDesc: 'Professional Matte',
  },
  whyBuy: {
    title: '🌟 Why Buy From Us?',
    items: [
      { icon: '✨', title: 'Premium Quality', description: 'Professional-grade brushes that beauty influencers love and recommend.' },
      { icon: '🔒', title: 'Safe Transaction', description: 'Cash on Delivery available, inspect the product before paying.' },
      { icon: '💎', title: 'Long Lasting', description: 'Durable brushes that maintain their shape wash after wash.' },
      { icon: '🚚', title: 'Fast Delivery', description: 'Quick delivery all over Bangladesh.' },
    ],
  },
  reviews: {
    title: '💕 Our Happy', highlight: 'Customers',
    subtitle: 'Join thousands of beauty enthusiasts across Bangladesh',
    items: [
      { name: 'Fatima Rahman', location: 'Dhaka', text: 'These brushes are so soft! My makeup has never looked better. Worth every taka!', rating: 5 },
      { name: 'Nusrat Jahan', location: 'Chittagong', text: 'Best brushes I have ever used. The blending is so smooth and effortless!', rating: 5 },
      { name: 'Anika Islam', location: 'Sylhet', text: 'Perfect for daily use. The quality is amazing for the price. Highly recommend!', rating: 5 },
    ],
    stats: { reviews: '500+', reviewsLabel: 'Happy Customers', rating: '4.9', ratingLabel: 'Average Rating', sold: '2,000+', soldLabel: 'Sets Sold' },
  },
  faq: {
    title: 'Frequently Asked', highlight: 'Questions',
    items: [
      { question: 'Are the brushes cruelty-free?', answer: 'Yes! All our brushes use 100% synthetic bristles and are completely cruelty-free.' },
      { question: 'How do I clean the brushes?', answer: 'Gently wash with mild soap and lukewarm water. Reshape bristles and lay flat to dry.' },
      { question: 'How long does delivery take?', answer: 'Inside Dhaka: 1-2 business days. Outside Dhaka: 3-5 business days. We ship all over Bangladesh!' },
      { question: 'What is your return policy?', answer: 'Exchange is available for damaged or incorrect items. Please check the parcel in front of the delivery person; complaints after they leave are not accepted.' },
      { question: 'Which option should I choose?', answer: 'We currently offer the 13-piece set for the best value.' },
    ],
  },
  codSection: {
    title: 'Receive the product, check it, then pay.',
    note: 'Note: If the product is not the same or there is any issue, free return is available.',
  },
  orderForm: {
    title: 'Order Your Loren Aura Brush', yourProducts: 'Your Products', product: 'Product', quantity: 'Quantity', price: 'Price',
    colorLabel: 'Color', colorRequired: 'Please select at least one color.', colors: { rose: 'Rose', purple: 'Purple', green: 'Green' },
    cardTapToAdd: 'Tap to add this color.', cardTapToDecrease: 'Tap to decrease quantity by 1.',
    billingDetails: 'Billing Details', yourName: 'Your Name', yourAddress: 'Your Address', mobileNumber: 'Mobile Number',
    shipping: 'Delivery Area', shippingOptions: { insideDhaka: 'Inside Dhaka City', outsideDhaka: 'Outside Dhaka City', outsideDistrict: 'Outside Dhaka District' },
    yourOrder: 'Your Order', cashOnDelivery: 'Cash on Delivery', codDescription: 'Pay with cash upon delivery.',
    privacyNote: 'Your personal data will be used to process your order.', placeOrder: 'Place Order', processing: 'Processing...',
    insideDhaka: 'Inside Dhaka', outsideDhaka: 'Outside Dhaka', free: 'FREE', orderSuccess: 'Order Placed Successfully!',
    orderNumber: 'Order Number', thankYou: 'Thank you for your order. We will contact you soon.',
  },
  whatsapp: { title: 'Message us on WhatsApp for any questions', number: '01943852435' },
  footer: {
    brand: 'Loren Aura', tagline: 'Premium makeup brushes for flawless beauty', contact: 'Contact',
    phone: '+880 1943-852435', email: 'hello@lorenaura.com', location: 'Dhaka, Bangladesh', followUs: 'Follow Us',
    copyright: '© 2026 Loren Aura. All rights reserved.', madeWith: 'Made with', inBangladesh: 'in Bangladesh', designedBy: 'Designed by',
  },
  stickyAtc: { addToCart: 'Order Now', buyNow: 'Order Now' },
  cart: { title: 'Shopping Cart', empty: 'Your cart is empty', startShopping: 'Start shopping to add items', subtotal: 'Subtotal', shipping: 'Shipping calculated at checkout', checkout: 'Proceed to Checkout', continueShopping: 'Continue Shopping', remove: 'Remove' },
  checkout: {
    title: 'Delivery Information', orderConfirmed: 'Order Confirmed!', cod: 'Cash on Delivery', codDesc: 'Pay when you receive the product',
    contactInfo: 'Contact Information', fullName: 'Full Name', phone: 'Phone Number', email: 'Email (Optional)',
    deliveryAddress: 'Delivery Address', address: 'Full Address', addressPlaceholder: 'House no, Road no, Building name',
    area: 'Area', areaPlaceholder: 'e.g. Gulshan, Mirpur, Uttara', district: 'District', notes: 'Order Notes (Optional)', notesPlaceholder: 'Any special instructions...',
    orderSummary: 'Order Summary', subtotal: 'Subtotal', delivery: 'Delivery', insideDhaka: 'Inside Dhaka', outsideDhaka: 'Outside Dhaka',
    total: 'Total', confirmOrder: 'Confirm Order', processing: 'Processing...', thankYou: 'Thank You!',
    orderSuccess: 'Your order has been placed successfully.', orderNumber: 'Order Number', payment: 'Payment Method',
    estimatedDelivery: 'Estimated Delivery', days12: '1-2 Days', days35: '3-5 Days', contactSoon: 'We will contact you shortly to confirm your order.',
    continueShopping: 'Done', submitError: 'Failed to submit order. Please try again.', nameRequired: 'Name is required',
    phoneRequired: 'Phone number is required', phoneInvalid: 'Please enter a valid Bangladesh phone number',
    emailInvalid: 'Please enter a valid email address', addressRequired: 'Address is required', areaRequired: 'Area is required',
  },
  notification: { addedToCart: 'Added to cart!', itemAdded: 'item added to cart!', itemsAdded: 'items added to cart!' },
};

// Bengali translations
const bn = {
  nav: { features: 'বৈশিষ্ট্য', specs: 'বিবরণ', reviews: 'রিভিউ', faq: 'প্রশ্নোত্তর', order: 'অর্ডার করুন' },
  announcement: { text: 'ঢাকার ভেতরে ফ্রি ডেলিভারি', highlight: 'এখনই অর্ডার করুন!' },
  hero: {
    tagline: 'প্রফেশনাল মেকআপ ব্রাশ',
    title: 'Loren Aura',
    subtitle: 'Exclusive ১৩ পিস মেক-আপ ব্রাশ সেট — অ্যালুমিনিয়াম হ্যান্ডেল, উন্নত ফাইবার ব্রিসল',
    // description: 'স্লিকলাক্সারি কন্ট্রোল ও সিল্ক-সফট ফিনিশ।',
    addToCart: 'কার্টে যোগ করুন', buyNow: 'এখনই অর্ডার করুন', freeShipping: 'ঢাকার ভেতরে ফ্রি ডেলিভারি',
    selectVariant: 'অপশন বাছুন', popular: 'সেরা মূল্য', freeDelivery: 'ঢাকার ভেতরে ফ্রি ডেলিভারি',
  },
  features: {
    title: 'কেন বেছে নিবেন', highlight: 'লরেন অরা',
    subtitle: 'আধুনিক বিউটি লাভারদের জন্য প্রফেশনাল কোয়ালিটি ব্রাশ',
    items: [
      { icon: '✨', label: 'নরম ও স্কিন ফ্রেন্ডলি – সংবেদনশীল ত্বকের জন্যও নিরাপদ' },
      { icon: '⏱️', label: 'দীর্ঘদিন ব্যবহারযোগ্য – নিয়মিত ব্যবহারে টেকসই মান' },
      { icon: '🎨', label: 'দাগছাড়া নিখুঁত ব্লেন্ড – মসৃণ ও প্রফেশনাল ফিনিশ' },
      { icon: '❌', label: 'ঝরে না – ব্যবহারকালে কোনো চুল উঠে আসে না' },
      { icon: '💪', label: 'টেকসই ব্রাশ হেয়ার – উন্নত মানের, লং-লাস্টিং ব্রিসল' },
    ],
  },
  setContents: {
    title: '১৩ পিস মেকআপ ব্রাশ সেট',
    items: [
      { icon: '👤', label: 'ফেস ব্রাশ × ৫ (পাউডার, ফাউন্ডেশন, এঙ্গেলড কনট্যুর, ব্লাশ, হাইলাইট)' },
      { icon: '✨', label: 'কনসিলার ব্রাশ × এক ' },
      { icon: '👁️', label: 'আই শ্যাডো ব্রাশ × ৫ (ছোট আই শ্যাডো, স্মোকি, ব্লেন্ডিং, ডিটেইল, সিল্কওয়ার্ম)' },
      { icon: '✔️', label: 'আইব্রো ব্রাশ × এক ' },
      { icon: '💋', label: 'লিপ ব্রাশ × এক ' },
    ],
  },
  useCases: {
    title: 'যেখানে ব্যবহার করবেন',
    items: ['প্রতিদিনের মেকআপ রুটিনে', 'স্পেশাল অকেশন ও ইভেন্টে', 'প্রফেশনাল মেকআপ আর্টিস্টদের জন্য', 'বিউটি লাভারদের গিফট হিসেবে', 'ট্রাভেল ও অন-দ্য-গো টাচ-আপে'],
  },
  productNotes: {
    title: '💄 প্রোডাক্ট ডিটেইলস',
    description: 'আমাদের ব্রাশগুলোতে আল্ট্রা-সফট সিন্থেটিক ব্রিসলস রয়েছে যা প্রোডাক্ট সুন্দরভাবে পিক আপ করে এবং সিমলেসলি ব্লেন্ড করে। এরগোনমিক হ্যান্ডেল প্রতিবার নিখুঁত কন্ট্রোল দেয়।',
    topNote: 'ব্রিসলস', topNoteDesc: 'আল্ট্রা সফট সিন্থেটিক',
    middleNote: 'হ্যান্ডেল', middleNoteDesc: 'এরগোনমিক উড',
    baseNote: 'ফিনিশ', baseNoteDesc: 'প্রফেশনাল ম্যাট',
  },
  whyBuy: {
    title: '🌟 কেন আমাদের থেকে কিনবেন?',
    items: [
      { icon: '✨', title: 'প্রিমিয়াম কোয়ালিটি', description: 'প্রফেশনাল-গ্রেড ব্রাশ যা বিউটি ইনফ্লুয়েন্সাররা পছন্দ করেন।' },
      { icon: '🔒', title: 'নিরাপদ লেনদেন', description: 'ক্যাশ অন ডেলিভারি, পেমেন্টের আগে প্রোডাক্ট চেক করুন।' },
      { icon: '💎', title: 'দীর্ঘস্থায়ী', description: 'টেকসই ব্রাশ যা বারবার ধোয়ার পরেও শেইপ ধরে রাখে।' },
      { icon: '🚚', title: 'দ্রুত ডেলিভারি', description: 'সারা বাংলাদেশে দ্রুত ডেলিভারি।' },
    ],
  },
  reviews: {
    title: '💕 আমাদের সন্তুষ্ট', highlight: 'কাস্টমারগণ',
    subtitle: 'বাংলাদেশ জুড়ে হাজারো বিউটি এনথুসিয়াস্টদের সাথে যোগ দিন',
    items: [
      { name: 'ফাতিমা রহমান', location: 'ঢাকা', text: 'এই ব্রাশগুলো এত সফট! আমার মেকআপ আগে কখনো এত ভালো হয়নি। সার্থক প্রতিটি টাকা!', rating: 5 },
      { name: 'নুসরাত জাহান', location: 'চট্টগ্রাম', text: 'আমি যত ব্রাশ ব্যবহার করেছি এটা সবচেয়ে ভালো। ব্লেন্ডিং এত স্মুথ!', rating: 5 },
      { name: 'আনিকা ইসলাম', location: 'সিলেট', text: 'প্রতিদিনের ব্যবহারের জন্য পারফেক্ট। দামের তুলনায় কোয়ালিটি অসাধারণ!', rating: 5 },
    ],
    stats: { reviews: '৫০০+', reviewsLabel: 'সন্তুষ্ট কাস্টমার', rating: '৪.৯', ratingLabel: 'গড় রেটিং', sold: '২,০০০+', soldLabel: 'সেট বিক্রি' },
  },
  faq: {
    title: 'সচরাচর জিজ্ঞাসিত', highlight: 'প্রশ্নাবলী',
    items: [
      { question: 'ব্রাশগুলো কি ক্রুয়েল্টি-ফ্রি?', answer: 'হ্যাঁ! আমাদের সব ব্রাশে ১০০% সিন্থেটিক ব্রিসলস ব্যবহার করা হয়েছে এবং সম্পূর্ণ ক্রুয়েল্টি-ফ্রি।' },
      { question: 'ব্রাশ কিভাবে পরিষ্কার করব?', answer: 'হালকা সাবান ও হালকা গরম পানি দিয়ে আলতো করে ধুয়ে নিন। ব্রিসলস রিশেইপ করে সমতলে শুকাতে দিন।' },
      { question: 'ডেলিভারি কতদিনে হয়?', answer: 'ঢাকার ভেতরে: ১-২ কার্যদিবস। ঢাকার বাইরে: ৩-৫ কার্যদিবস। সারা বাংলাদেশে ডেলিভারি!' },
      { question: 'রিটার্ন পলিসি কী?', answer: 'ক্ষতিগ্রস্ত বা ভুল প্রোডাক্ট পেলে এক্সচেঞ্জ করা হয়। ডেলিভারি ম্যানের সামনে পারসেল চেক করে নিন; তিনি চলে যাওয়ার পর কোনো অভিযোগ গ্রহণযোগ্য হবে না।' },
      { question: 'কোন অপশনটি বেছে নেব?', answer: 'বর্তমানে ১৩-পিস সেটটাই পাওয়া যায় এবং এটিই সেরা ভ্যালু।' },
    ],
  },
  codSection: {
    title: 'পণ্য হাতে পেয়ে, দেখে নিন, তারপর মূল্য পরিশোধ করুন।',
    note: 'নোট: পণ্যটি একই না হলে অথবা কোনো সমস্যা থাকলে ফ্রি রিটার্ন করার সুবিধা আছে।',
  },
  orderForm: {
    title: 'আপনার লরেন অরা ব্রাশ অর্ডার করুন', yourProducts: 'আপনার প্রোডাক্ট', product: 'প্রোডাক্ট', quantity: 'পরিমাণ', price: 'দাম',
    colorLabel: 'রং', colorRequired: 'অন্তত একটি রং নির্বাচন করুন।', colors: { rose: 'রোজ', purple: 'বেগুনি', green: 'সবুজ' },
    cardTapToAdd: 'ট্যাপ করে এই রং যোগ করুন।', cardTapToDecrease: 'ট্যাপ করে পরিমাণ ১ কমান।',
    billingDetails: 'বিলিং তথ্য', yourName: 'আপনার নাম', yourAddress: 'আপনার ঠিকানা', mobileNumber: 'মোবাইল নম্বর',
    shipping: 'ডেলিভারি এলাকা', shippingOptions: { insideDhaka: 'ঢাকা সিটির ভেতর', outsideDhaka: 'ঢাকা সিটির বাইরে', outsideDistrict: 'ঢাকা জেলার বাইরে' },
    yourOrder: 'আপনার অর্ডার', cashOnDelivery: 'ক্যাশ অন ডেলিভারি', codDescription: 'পণ্য হাতে পেয়ে টাকা দিন।',
    privacyNote: 'আপনার ব্যক্তিগত তথ্য শুধুমাত্র অর্ডার প্রসেসিংয়ের জন্য ব্যবহৃত হবে।', placeOrder: 'অর্ডার করুন', processing: 'প্রসেসিং...',
    insideDhaka: 'ঢাকার ভেতরে', outsideDhaka: 'ঢাকার বাইরে', free: 'ফ্রি', orderSuccess: 'অর্ডার সফলভাবে সম্পন্ন হয়েছে!',
    orderNumber: 'অর্ডার নম্বর', thankYou: 'আপনার অর্ডারের জন্য ধন্যবাদ। শীঘ্রই আপনার সাথে যোগাযোগ করা হবে।',
  },
  whatsapp: { title: 'যেকোনো প্রশ্নের জন্য আমাদের হোয়াটসঅ্যাপে মেসেজ করুন', number: '০১৯৪৩৮৫২৪৩৫' },
  footer: {
    brand: 'লরেন অরা', tagline: 'নিখুঁত সৌন্দর্যের জন্য প্রিমিয়াম মেকআপ ব্রাশ', contact: 'যোগাযোগ',
    phone: '+৮৮০ ১৯৪৩-৮৫২৪৩৫', email: 'hello@lorenaura.com', location: 'ঢাকা, বাংলাদেশ', followUs: 'ফলো করুন',
    copyright: '© ২০২৬ লরেন অরা। সর্বস্বত্ব সংরক্ষিত।', madeWith: 'তৈরি করা হয়েছে', inBangladesh: 'বাংলাদেশে', designedBy: 'ডিজাইন করেছেন',
  },
  stickyAtc: { addToCart: 'অর্ডার করুন', buyNow: 'এখনই অর্ডার করুন' },
  cart: { title: 'শপিং কার্ট', empty: 'আপনার কার্ট খালি', startShopping: 'শপিং শুরু করুন', subtotal: 'সাবটোটাল', shipping: 'শিপিং চেকআউটে দেখানো হবে', checkout: 'চেকআউট করুন', continueShopping: 'শপিং চালিয়ে যান', remove: 'সরান' },
  checkout: {
    title: 'ডেলিভারি তথ্য', orderConfirmed: 'অর্ডার সফল!', cod: 'ক্যাশ অন ডেলিভারি', codDesc: 'পণ্য হাতে পেয়ে টাকা দিন',
    contactInfo: 'যোগাযোগের তথ্য', fullName: 'পুরো নাম', phone: 'ফোন নম্বর', email: 'ইমেইল (ঐচ্ছিক)',
    deliveryAddress: 'ডেলিভারি ঠিকানা', address: 'পুরো ঠিকানা', addressPlaceholder: 'বাড়ি নং, রোড নং, বিল্ডিং এর নাম',
    area: 'এলাকা', areaPlaceholder: 'যেমন: গুলশান, মিরপুর, উত্তরা', district: 'জেলা', notes: 'অর্ডার নোট (ঐচ্ছিক)', notesPlaceholder: 'বিশেষ কোনো নির্দেশনা...',
    orderSummary: 'অর্ডার সামারি', subtotal: 'সাবটোটাল', delivery: 'ডেলিভারি', insideDhaka: 'ঢাকার ভেতরে', outsideDhaka: 'ঢাকার বাইরে',
    total: 'মোট', confirmOrder: 'অর্ডার নিশ্চিত করুন', processing: 'প্রসেসিং...', thankYou: 'ধন্যবাদ!',
    orderSuccess: 'আপনার অর্ডার সফলভাবে সম্পন্ন হয়েছে।', orderNumber: 'অর্ডার নম্বর', payment: 'পেমেন্ট মেথড',
    estimatedDelivery: 'আনুমানিক ডেলিভারি', days12: '১-২ দিন', days35: '৩-৫ দিন', contactSoon: 'শীঘ্রই অর্ডার নিশ্চিত করতে আপনার সাথে যোগাযোগ করা হবে।',
    continueShopping: 'সম্পন্ন', submitError: 'অর্ডার জমা দিতে ব্যর্থ। আবার চেষ্টা করুন।', nameRequired: 'নাম প্রয়োজন',
    phoneRequired: 'ফোন নম্বর প্রয়োজন', phoneInvalid: 'সঠিক বাংলাদেশি ফোন নম্বর দিন',
    emailInvalid: 'সঠিক ইমেইল ঠিকানা দিন', addressRequired: 'ঠিকানা প্রয়োজন', areaRequired: 'এলাকা প্রয়োজন',
  },
  notification: { addedToCart: 'কার্টে যোগ হয়েছে!', itemAdded: 'টি প্রোডাক্ট কার্টে যোগ হয়েছে!', itemsAdded: 'টি প্রোডাক্ট কার্টে যোগ হয়েছে!' },
};

const translations = { en, bn };

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'bn';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = translations[language];
  const toggleLanguage = () => setLanguage(prev => prev === 'en' ? 'bn' : 'en');

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within a LanguageProvider');
  return context;
};

export default LanguageContext;






